(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
const bagForm = document.getElementById('ConversionCartForm');
if (bagForm) {
  const update = bagForm.querySelector('#BagUpdate');
  let submitting = false;
  const save = () => {
    if (submitting || !bagForm.reportValidity()) return;
    submitting = true;
    bagForm.requestSubmit(update);
  };
  bagForm.querySelectorAll('[data-bag-step]').forEach(button => button.addEventListener('click', () => {
    if (submitting) return;
    const input = button.closest('.bag-stepper').querySelector('input');
    const previous = Number(input.value);
    input.value = Math.max(0, previous + Number(button.dataset.bagStep));
    if (Number(input.value) !== previous) save();
  }));
  bagForm.querySelectorAll('input[name="updates[]"]').forEach(input => input.addEventListener('change', save));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-product-feedback]').forEach(section=>{
  const target=document.querySelector('[data-shipping-panel]');
  if(!target||section.closest('.product-review-panel'))return;
  const panel=document.createElement('details');panel.className='product-detail product-review-panel';
  const summary=document.createElement('summary');summary.textContent=section.dataset.cardTitle;
  panel.append(summary);target.before(panel);panel.append(section);
  if(section.querySelector('.feedback-success,.errors'))panel.open=true;
});
document.querySelectorAll('.feedback-write').forEach(link=>link.addEventListener('click',()=>{const panel=document.querySelector(link.getAttribute('href'));if(panel)panel.open=true;}));
document.querySelectorAll('.feedback-form-panel').forEach(panel=>{if(panel.querySelector('.feedback-success,.errors'))panel.open=true;});

  } catch(e) { console.error(e); }
})();
})();
